import assert from 'assert';

import {CustomContextPackage, makeReactContext} from 'lib/makeReactContext';

export interface MethodEditorContextValue {
  selectedStepCid: string | null;
  currentMethodId: string | null;
  stepCidToIdMap: Record<string, string | null>;
}

/**
 * A version of the MethodEditorContext that allows for use without a surrounding Provider. This cannot be
 * used directly and should only be done via useNullableMethodEditorContext.
 */
const NullableMethodEditorContext = makeReactContext<MethodEditorContextValue | null>(
  () => null,
  'MethodEditorContext'
);

/** Context containing info about a Method Editor. Throws an error when trying to access outside of a set context. */
const MethodEditorContext: CustomContextPackage<MethodEditorContextValue> = {
  ...NullableMethodEditorContext,
  useContext: () => {
    const context = NullableMethodEditorContext.useContext();
    assert(
      context,
      'Unable to run without a MethodEditorContext. In tests, use a proper test setup with MethodEditorContext.Provider'
    );
    return context;
  },
};

/** The same as MethodEditorContext.useContext(), except that it doesn't require the context be provided. */
export function useNullableMethodEditorContext(): MethodEditorContextValue | null {
  return NullableMethodEditorContext.useContext();
}

export default MethodEditorContext;
